// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mainDiv {
    margin-left: 200px;
}

.spanStyles {
    font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
}

.divStyles{
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  overflow-x: scroll;
}


.circleImage {
    width: 100px;
    height: 100px;
    border-radius: 50px;
    margin-right: 10px;
    object-fit: cover;
    background-color: #d7d7d7;
}

.imageContainer {
    display: flex;
    margin: 40px 0px 40px 100px;
    margin-left: 15%;
}

.profileStateDiv {
    margin-bottom: 40px;
}

.buttonDiv {
    display: flex; 
    top: 80%; 
    left: 37%; 
    position: absolute
}

.cancelButton {
    background-color: #d7d7d7;
}`, "",{"version":3,"sources":["webpack://./src/components/styles/Review.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;EAC5B,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB;AACF;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,WAAW;EACX,kBAAkB;AACpB;;;AAGA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;IACT;AACJ;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".mainDiv {\n    margin-left: 200px;\n}\n\n.spanStyles {\n    font-family: 'Gilory-Semi';\n  font-size: 20px;\n  font-stretch: normal;\n  font-style: normal;\n  line-height: normal;\n  letter-spacing: normal;\n  font-weight: 800;\n  color: #767676\n}\n\n.divStyles{\n  position: absolute;\n  top: 45%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 100%;\n  overflow-x: scroll;\n}\n\n\n.circleImage {\n    width: 100px;\n    height: 100px;\n    border-radius: 50px;\n    margin-right: 10px;\n    object-fit: cover;\n    background-color: #d7d7d7;\n}\n\n.imageContainer {\n    display: flex;\n    margin: 40px 0px 40px 100px;\n    margin-left: 15%;\n}\n\n.profileStateDiv {\n    margin-bottom: 40px;\n}\n\n.buttonDiv {\n    display: flex; \n    top: 80%; \n    left: 37%; \n    position: absolute\n}\n\n.cancelButton {\n    background-color: #d7d7d7;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
